export const LIST_MAIN_NEWSLETTER = 22
export const LIST_NOS_GESTES_TRANSPORT_NEWSLETTER = 32
export const LIST_NOS_GESTES_LOGEMENT_NEWSLETTER = 36
